export const formBuilder = {
  title: "Form Builder",
  description: "Send forms to those contributing to the project so they can fill in author and recording details. These will then appear in the list view and can be dragged and dropped onto existing pins in the list.",
  elements: "Choose which elements you require the recipient to complete.",
  sections: {
    formFieldsTitle: "Form fields",
    formFieldsFilter: "Toggle fields to include on the submission form:",
    formFieldsHint: "{{enabled}} of {{total}} elements required",
    passwordDescription: "Optional password listeners must enter before they can open the submission form.",
    passwordPlaceholder: "Leave blank for no password",
    actionsTitle: "Actions",
    actionsDescription: "Save settings, preview the public form, or copy a shareable link.",
  },
  locationInfo: "Location Information",
  authorInfo: "Author Information",
  recordingInfo: "Recording Information",
  uploadFields: "Upload Fields",
  fieldHelp: {
    moreInfoAriaLabel: "More information about this field",
    locationInfo: "Ask contributors where the pin should be placed. They can search by address, postcode, or coordinates and confirm the location on the map.",
    authorInfo: "Collect the artist or author details for the recording. This information appears in the app library so listeners can identify and connect with the creator.",
    recordingInfo: "Collect recording metadata such as title, description, narrator, content rating, and tags. Use this when you need details about the audio itself.",
    uploadFields: "Allow contributors to upload an audio file, record directly in the browser, or provide an audio URL.",
    password: "Optionally protect the form with a password. Contributors must enter it before they can access and submit the form. Leave blank for public access.",
    locationAddress: "Enter an address, postcode, or coordinates, then use Search to place the pin on the map.",
    authorName: "The name of the person who created the recording. This is shown in the app and added as an author tag.",
    authorBio: "A short biography for the author. This appears in the app library when listeners view the creator's profile.",
    authorWebsite: "An optional link to the author's website or social profile.",
    authorTags: "Additional tags to help categorise the author. The author name is added automatically.",
    authorImage: "An optional profile image for the author, shown in the app library.",
    recordingTitle: "The name of the recording as it will appear to listeners in the app.",
    recordingDescription: "Optional extra context about the recording content.",
    recordingNarrator: "Who speaks in the recording, if different from the author name.",
    contentRating: "Helps listeners receive content suitable for their preferences.",
    subjectTags: "Tags describing what the recording is about, such as themes or topics.",
    genreTags: "Tags describing the style or genre of the recording.",
    audioUpload: "Upload an MP3, record audio in the browser, or paste an audio URL. This is the audio listeners will hear.",
    transcription: "Optional text version of the audio. Helps deaf and hard-of-hearing listeners access the content.",
    speakerMode: "Choose whether one or multiple people speak in the recording. Multiple speakers enables diarisation in transcription.",
  },
  passwordLabel: "Add a password for Form Access:",
  saveConfiguration: "Save Configuration",
  viewForm: "View Form",
  shareFormLink: "Share Form Link",
  buttons: {
    saveForm: "Save Form",
    updateForm: "Update Form"
  },
  labels: {
    locationInformation: "Location Information:",
    recordingInformation: "Recording Information",
    search: "Search",
    searching: "Searching...",
    goToAuthorDashboard: "Go to Author Dashboard",
    locationAddressLabel: "Location Address/Postcode/Coordinates"
  },
  errors: {
    noProjectSelected: "No project selected!",
    copyLinkFailed: "Failed to copy link to clipboard. Please try again."
  },
  success: {
    configurationSaved: "Configuration saved successfully",
    formLinkCopied: "Form link copied to clipboard"
  },
  validation: {
    formTitleRequired: "Form title is required",
    submitButtonTextRequired: "Submit button text is required",
    questionTitleRequired: "Question title is required",
    atLeastTwoOptions: "At least two options are required",
    allOptionsMustHaveContent: "All options must have content",
    maxMustBeGreaterThanMin: "Maximum value must be greater than minimum value",
    bothLabelsRequired: "Both minimum and maximum labels are required",
    allThreePointsRequired: "All three points must be labelled",
    answerAllRequired: "Please answer all required questions"
  },
  recordingForm: {
    reusedArtistDetails: "Using artist details reused for this project in this session.",
    clearReusedArtistDetails: "Clear reused artist details",
    success: {
      title: "Thank you for your submission!",
      messageForm: "Your recording has been successfully submitted. Thank you for your contribution!",
      messageEditor: "Please close this screen or choose an option below:",
      submitAnother: "Submit Another",
      submitAnotherWithSameArtist: "Submit Another with Same Artist Details",
      addAnotherRecording: "Add Another Recording"
    }
  }
}
